module.exports = __webpack_public_path__ + "assets/img/auction_flow.53ad5d69.png";